<form [formGroup]="formGroup">
	<div [formArrayName]="formArrayName">
		@if (formArray.controls.length > 0) {
			@for (control of formArray.controls; track $index) {
				<div class="flex-grow-1 flex gap-2" [formGroupName]="$index">
					@for (field of subsection.fields; track $index) {
						<div class="flex-1 gap-2">
						<span class="section_column"
									[style.margin-bottom]="field.required ? '0' : '20px'">{{field.label}}</span>
							<small id="field-help" style="color: red">
								{{ field.required ? "*Required" : "" }}
							</small>
							@switch (field.type) {
								@case ('text') {
									<mat-form-field appearance="outline" class="w-100">
										<input matInput type="text" aria-describedby="field-help" [formControlName]="field.field" />
									</mat-form-field>
								}
								@case ('integer') {
									<mat-form-field appearance="outline" class="w-100">
										<input matInput type="number" aria-describedby="field-help" [formControlName]="field.field" step="1" />
									</mat-form-field>
								}
								@case ('decimal') {
									<mat-form-field appearance="outline" class="w-100">
										<input matInput type="number" aria-describedby="field-help" [formControlName]="field.field" step="0.01" />
									</mat-form-field>
								}
								@case ('dropdown') {
									<mat-form-field appearance="outline" class="w-100">
										<mat-select [formControlName]="field.field" [placeholder]="'Select a ' + field.label">
											@for (option of field.options; track option.value) {
												<mat-option [value]="option.value">{{option.name}}</mat-option>
											}
										</mat-select>
									</mat-form-field>
								}
								@case ('multi') {
									<mat-form-field appearance="outline" class="w-100">
										<mat-select [formControlName]="field.field" [placeholder]="'Select a ' + field.label" multiple>
											@for (option of field.options; track option.value) {
												<mat-option [value]="option.value">{{option.name}}</mat-option>
											}
										</mat-select>
									</mat-form-field>
								}
							}
						</div>
					}
					<button mat-icon-button
										color="primary"
										[matTooltip]="'Remove ' + subsection.category"
										[style.margin-top]="'39px'"
										(click)="removeRow(subsection.id, $index)">
						<mat-icon>close</mat-icon>
					</button>
				</div>
			}
		} @else {
			<div>No data</div>
		}
	</div>
</form>
